@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row.coupon_type == 'Vanity') {
    <div (click)="OpenCouponPopup($.row)" class="cursor-pointer text-primary">
      {{ getCouponCount($.row) }}
      {{
        getCouponCount($.row) > 1
          ? ('ADMIN.COUPON.CODES' | translate)
          : ('ADMIN.COUPON.CODE' | translate)
      }}
    </div>
  }
  @if ($.row.coupon_type != 'Vanity') {
    <div (click)="OpenCouponPopup($.row)" class="cursor-pointer text-primary">
      {{ $.row.coupon_codes.length }}
      {{
        $.row.coupon_codes.length > 1
          ? ('ADMIN.COUPON.CODES' | translate)
          : ('ADMIN.COUPON.CODE' | translate)
      }}
    </div>
  }
}

@if (showSingleUseCoupon | async; as showPopup) {
  <app-single-use-coupon
    [visible]="showPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [couponMaster]="couponMaster"
    (closePopup)="closePopup($event)"
  />
}

@if (showVanityCoupon | async; as showPopup) {
  <app-vanity-coupon
    [visible]="showPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [couponMaster]="couponMaster"
    (closePopup)="closePopup($event)"
  />
}
